import events from 'events-bus';
import { useEffect, useState } from 'react';
import { AUTH_SUCCESS } from '../utils/Events';

const useToken = () => {
  const [token, setToken] = useState<string>();
  useEffect(() => {
    const tokenListener = (_: any, data: { token: string }) => {
      const token = data.token;
      setToken(token);
    };

    events.on(AUTH_SUCCESS, tokenListener);
    return () => {
      events.off(tokenListener);
    };
  }, []);

  return { token };
};

export default useToken;
